export default __webpack_public_path__ + "static/media/JCI.5eed9712.png";